import type { MouseEvent } from 'react'
import { MenuLinkItem } from '@sunwebgroup/uds-ui/menu'
import { useIntl } from '@/intl'
import styles from './SkipLinks.module.css'
import { focusSkipLinkTarget, resolveSkipLinkTarget } from './skipLinkTargets'
import { useAvailableSkipLinkTargets } from './useAvailableSkipLinkTargets'
import { useResetFocusOnRouteChange } from './useResetFocusOnRouteChange'

export function SkipLinks() {
  const intl = useIntl()
  const availableTargets = useAvailableSkipLinkTargets()

  useResetFocusOnRouteChange()

  const handleClick = (id: string) => (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()

    const target = resolveSkipLinkTarget(id)

    if (!target) {
      return
    }

    focusSkipLinkTarget(target)
  }

  return (
    <ul className={styles.skipLinks}>
      {availableTargets.map(({ id, href, labelKey }) => (
        <li key={id}>
          <MenuLinkItem href={href} className={styles.link} onClick={handleClick(id)}>
            {intl.formatMessage({ id: labelKey })}
          </MenuLinkItem>
        </li>
      ))}
    </ul>
  )
}
